import Vue from 'vue'

const initialState = {
  list: [],
  financingSource: {},
  loading: false
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    }
  },
  actions: {
    getList({commit}, {params, projectId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/projects/${projectId}/financing_sources/`, {params}).then(response => {
          commit('SET', {key: 'list', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getFinancingSource({commit}, {projectId, financingSourceId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`project_control/projects/${projectId}/financing_sources/${financingSourceId}/`).then(response => {
          commit('SET', {key: 'financingSource', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    create({commit}, {financingSource, projectId}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.post(`project_control/projects/${projectId}/financing_sources/`, financingSource).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    update({commit}, {projectId, financingSource}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.put(`project_control/projects/${projectId}/financing_sources/${financingSource.id}/`, financingSource).then(response => {
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    remove({commit}, {projectId, financingSourceId}) {
      commit('SET', {key: 'loading', val: true})
      return new Promise((resolve, reject) => {
        Vue.axios.delete(`project_control/projects/${projectId}/financing_sources/${financingSourceId}/`).then(() => {
          resolve()
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
